export const opcoesRetornoRealInvestimento = [
  { value: '0', label: '0%' },
  { value: '1', label: '1%' },
  { value: '2', label: '2%' },
  { value: '3', label: '3%' },
  { value: '4', label: '4%' },
  { value: '4,5', label: '4,50%' },
  { value: '5', label: '5%' },
  { value: '5,3', label: '5,30%' },
];

export const opcoesRetornoRealInvestimentoTaesa = [
  { value: '4', label: '4%' },
  { value: '4,5', label: '4,50%' },
  { value: '5', label: '5%' },
  { value: '5,5', label: '5,50%' },
  { value: '6', label: '6%' },
  { value: '6,5', label: '6,50%' },
  { value: '7', label: '7%' },
  { value: '7,5', label: '7,50%' },
  { value: '8', label: '8%' },
  { value: '8,5', label: '8,50%' },
];
